var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('SiteHeader',{staticClass:"layout--site-header"}),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.showCustomerName)?_c('CustomerName',{key:`customer-name-${_vm.customerId}`}):_vm._e()],1),_c('router-view',{staticClass:"layout--router-view",attrs:{"is-window-small":_vm.isWindowSmall}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }